export const Menu = {
    SalesFUND_MANAGER_AUDIT_QUERYTIMERANGE: '查询时间范围',
    SalesFUND_MANAGER_AUDIT_QUERYTIMERANGE_TIME30: '近30天',
    SalesFUND_MANAGER_AUDIT_QUERYTIMERANGE_TIME60: '近60天',
    SalesFUND_MANAGER_AUDIT_QUERYTIMERANGE_TIME90: '近90天',
    SalesFUND_MANAGER_AUDIT_QUERYTIMERANGE_TIMEALL: '全部',
    SalesFUND_MANAGER_WALLET_QUERYTIMERANGE: '查询时间范围',
    SalesFUND_MANAGER_WALLET_QUERYTIMERANGE_TIME30: '近30天',
    SalesFUND_MANAGER_WALLET_QUERYTIMERANGE_TIME60: '近60天',
    SalesFUND_MANAGER_WALLET_QUERYTIMERANGE_TIME90: '近90天',
    SalesFUND_MANAGER_WALLET_QUERYTIMERANGE_TIMEALL: '全部',
    SalesCLIENT_MANAGER_LIST_DETAIL_IBREBATERELATED: 'IB返佣相关配置',
    SalesCLIENT_MANAGER_LIST_DETAIL_IBREBATERELATED_UPGRADEIB: '升级IB',
    SalesCLIENT_MANAGER_LIST_DETAIL_IBREBATERELATED_REBATECONFIG: 'IB返佣配置',
    SalesCLIENT_MANAGER_LIST_DETAIL_IBREBATERELATED_SHOWINTERESTFREEGROUP: '是否展示免息组',
    SalesCLIENT_MANAGER_LIST_DETAIL_IBREBATERELATED_SHOWLOWSPREADGROUP: '是否展示低点差组',
    SalesCLIENT_MANAGER_LIST_DETAIL_IBREBATERELATED_COPYNETTINGSTRATEGY: '是否开启Netting子类型复制返佣策略',
    SalesCLIENT_MANAGER_LIST_DETAIL_IBREBATERELATED_REBATESYNC: '是否开启返佣策略一键同步',
    SalesCLIENT_WORKORDER_UPGRADEIB: 'IB返佣配置工单列表',
    SalesCLIENT_WORKORDER_UPGRADEIB_CONFIG: 'IB返佣配置',
    SalesCLIENT_WORKORDER_UPGRADEIB_DETAIL: 'IB返佣配置工单详情',
    SalesCLIENT_MANAGER_IBREBATESTRATEGY: 'IB返佣策略',
    SalesTEAM_MANAGER_IBREBATESTRATEGY: 'IB返佣策略',
    SalesCLIENT_MANAGER_LIST_DETAIL_ROLEINFO_SALES_EDIT: '编辑所属销售',
    SalesTEAM_MANAGER_CLIENT_DETAIL_ROLEINFO_SALES_EDIT: '编辑所属销售',
};
